import type { TDatadogErrorLog } from 'utils/datadog/types'

export const WORKSPACE_GET_COMPANY_PLAN_LOG_ERROR: TDatadogErrorLog = {
  from: 'modules/global-topic/common/hooks/use-is-global-taxonomy',
  name: 'Get workspace data',
  message: 'Obtain the workspace data',
}
